import Activity from './pages/Activity.vue'
import Analytics from './pages/Analytics.vue'
import Update from './pages/Update.vue'
import Create from './pages/Create.vue'
import AutoCue from './pages/AutoCue.vue'
import Todo from './pages/Todo.vue'
import Recipe from './pages/Recipe.vue'
import RecipeTabsCreate from './pages/RecipeTabsCreate.vue'
import RecipeTabsUpdate from './pages/RecipeTabsUpdate.vue'
import PrintScript from './pages/PrintScript.vue'
import Login from './pages/Login.vue'
import LearnCreate from './pages/LearnCreate.vue'

function guardMyroute(to, from, next) {
    var isAuthenticated = false;
    if (localStorage.getItem('access'))
        isAuthenticated = true;
    else
        isAuthenticated = false;
    if (isAuthenticated) {
        next(); // allow to enter route
    }
    else {
        next('/login'); // go to '/login';
    }
}

const routes = [
    {
        path: '/',
        component: Activity,
        beforeEnter: guardMyroute
    },
    {
        path: '/workouts',
        component: Activity,
        beforeEnter: guardMyroute
    },
    {
        path: '/update-workout/:id',
        component: Update,
        beforeEnter: guardMyroute
    },
    {
        path: '/create-workout',
        component: Create,
        beforeEnter: guardMyroute
    },
    {
        path: '/warmup',
        component: Activity,
        beforeEnter: guardMyroute
    },
    {
        path: '/update-warmup/:id',
        component: Update,
        beforeEnter: guardMyroute
    },
    {
        path: '/create-warmup',
        component: Create,
        beforeEnter: guardMyroute
    },
    {
        path: '/stretch-flow',
        component: Activity,
        beforeEnter: guardMyroute
    },
    {
        path: '/update-stretch-flow/:id',
        component: Update,
        beforeEnter: guardMyroute
    },
    {
        path: '/create-stretch-flow',
        component: Create,
        beforeEnter: guardMyroute
    },
    {
        path: '/auto-cue/workout/:id',
        component: AutoCue,
        beforeEnter: guardMyroute
    },
    {
        path: '/auto-cue/warmup/:id',
        component: AutoCue,
        beforeEnter: guardMyroute
    },
    
    {
        path: '/auto-cue/stretch-flow/:id',
        component: AutoCue,
        beforeEnter: guardMyroute
    },
    {
        path: '/todo',
        component: Todo,
        beforeEnter: guardMyroute
    },
    {
        path: '/analytics',
        component: Analytics,
        beforeEnter: guardMyroute
    },
    {
        path: '/recipes',
        component: Recipe,
        beforeEnter: guardMyroute
    },
    {
        path: '/recipe/create',
        component: RecipeTabsCreate,
        beforeEnter: guardMyroute
    },
    {
        path: '/recipe/:id',
        component: RecipeTabsUpdate,
        beforeEnter: guardMyroute
    },
    {
        path: '/printscript/workout/:id',
        component: PrintScript,
        beforeEnter: guardMyroute
    },
    {
        path: '/printscript/warmup/:id',
        component: PrintScript,
        beforeEnter: guardMyroute
    },
    {
        path: '/printscript/stretch-flow/:id',
        component: PrintScript,
        beforeEnter: guardMyroute
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/learn/create',
        component: LearnCreate
    }

]

export default routes
